import * as Types from '../graphql.generated';

import { PropertiesSearchResponseErrorFragment } from './housePricesResults.query.generated';
import { gql } from '@apollo/client';
import { PropertiesSearchResponseErrorFragmentDoc } from './housePricesResults.query.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type HousePricesTrackedPropertiesQueryVariables = Types.Exact<{
    geoIdentifier?: Types.Maybe<Types.Scalars['GeoIdentifier']>;
    after?: Types.Maybe<Types.Scalars['ID']>;
    first?: Types.Maybe<Types.Scalars['PositiveInt']>;
    fromLastSaleDate?: Types.Maybe<Types.Scalars['String']>;
    propertyTypeCode?: Types.Maybe<Types.Scalars['String']>;
    sortDirection?: Types.Maybe<Types.Scalars['String']>;
    sortOrder?: Types.Maybe<Types.Scalars['String']>;
    toLastSaleDate?: Types.Maybe<Types.Scalars['String']>;
}>;

export type HousePricesTrackedPropertiesQuery = { __typename?: 'Query' } & {
    propertiesSearch:
        | ({ __typename?: 'PropertiesSearchConnection' } & {
              edges?: Types.Maybe<
                  Array<
                      Types.Maybe<
                          { __typename?: 'PropertiesSearchEdge' } & {
                              node?: Types.Maybe<
                                  { __typename?: 'Property' } & Pick<
                                      Types.Property,
                                      'uprn'
                                  > & {
                                          trackedProperty?: Types.Maybe<
                                              {
                                                  __typename?: 'TrackedProperty';
                                              } & Pick<
                                                  Types.TrackedProperty,
                                                  'isTracked'
                                              >
                                          >;
                                      }
                              >;
                          }
                      >
                  >
              >;
          })
        | ({
              __typename?: 'PropertiesSearchResponseError';
          } & PropertiesSearchResponseErrorFragment);
};

export const HousePricesTrackedPropertiesDocument = gql`
    query housePricesTrackedProperties(
        $geoIdentifier: GeoIdentifier
        $after: ID
        $first: PositiveInt
        $fromLastSaleDate: String
        $propertyTypeCode: String
        $sortDirection: String
        $sortOrder: String
        $toLastSaleDate: String
    ) {
        propertiesSearch(
            after: $after
            first: $first
            input: {
                geoIdentifier: $geoIdentifier
                fromLastSaleDate: $fromLastSaleDate
                propertyTypeCode: $propertyTypeCode
                sortDirection: $sortDirection
                sortOrder: $sortOrder
                toLastSaleDate: $toLastSaleDate
            }
        ) {
            ... on PropertiesSearchConnection {
                edges {
                    node {
                        uprn
                        trackedProperty {
                            isTracked
                        }
                    }
                }
            }
            ...PropertiesSearchResponseError
        }
    }
    ${PropertiesSearchResponseErrorFragmentDoc}
`;

/**
 * __useHousePricesTrackedPropertiesQuery__
 *
 * To run a query within a React component, call `useHousePricesTrackedPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHousePricesTrackedPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHousePricesTrackedPropertiesQuery({
 *   variables: {
 *      geoIdentifier: // value for 'geoIdentifier'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      fromLastSaleDate: // value for 'fromLastSaleDate'
 *      propertyTypeCode: // value for 'propertyTypeCode'
 *      sortDirection: // value for 'sortDirection'
 *      sortOrder: // value for 'sortOrder'
 *      toLastSaleDate: // value for 'toLastSaleDate'
 *   },
 * });
 */
export function useHousePricesTrackedPropertiesQuery(
    baseOptions?: Apollo.QueryHookOptions<
        HousePricesTrackedPropertiesQuery,
        HousePricesTrackedPropertiesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        HousePricesTrackedPropertiesQuery,
        HousePricesTrackedPropertiesQueryVariables
    >(HousePricesTrackedPropertiesDocument, options);
}
export function useHousePricesTrackedPropertiesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        HousePricesTrackedPropertiesQuery,
        HousePricesTrackedPropertiesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        HousePricesTrackedPropertiesQuery,
        HousePricesTrackedPropertiesQueryVariables
    >(HousePricesTrackedPropertiesDocument, options);
}
export type HousePricesTrackedPropertiesQueryHookResult = ReturnType<
    typeof useHousePricesTrackedPropertiesQuery
>;
export type HousePricesTrackedPropertiesLazyQueryHookResult = ReturnType<
    typeof useHousePricesTrackedPropertiesLazyQuery
>;
export type HousePricesTrackedPropertiesQueryResult = Apollo.QueryResult<
    HousePricesTrackedPropertiesQuery,
    HousePricesTrackedPropertiesQueryVariables
>;
